import { DateTime } from "luxon";
import type { ActionListActionFieldsFragment, EventListEventFieldsFragment } from "@/graphql";
import type { ActionFilters, EventFilters } from "./FilterTypes";

export function isEventActive(
  { updatedAt, eventFilters }: EventFilters,
  event: EventListEventFieldsFragment,
  boardId?: number,
  siteId?: number,
) {
  if (updatedAt < DateTime.fromISO(event.updatedAt)) {
    return true;
  }
  return eventFilters.every((filter) => {
    return filter.isEventActive(event, boardId, siteId);
  });
}

export function isActionActive(
  { updatedAt, actionFilters }: ActionFilters,
  action: ActionListActionFieldsFragment,
) {
  if (updatedAt < DateTime.fromISO(action.updatedAt)) {
    return true;
  }
  return actionFilters.every((filter) => {
    return filter.isActionActive(action);
  });
}
